export default __webpack_public_path__ + "static/media/icon-arrow-down.7fb564f7.svg";